/**
 * Route for `igaming-native-integrations-with-softswiss-pragmat`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingNativeIntegrationsWithSoftswissPragmatPage } from "../features/igaming-native-integrations-with-softswiss-pragmat/IgamingNativeIntegrationsWithSoftswissPragmatPage";

export const igamingNativeIntegrationsWithSoftswissPragmatRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-native-integrations-with-softswiss-pragmat",
	component: IgamingNativeIntegrationsWithSoftswissPragmatPage,
});

export default igamingNativeIntegrationsWithSoftswissPragmatRoute;
